module.exports = __webpack_public_path__ + "img/578.d9edf393.jpg";